// Copyright (c) 2017 Deere & Company

import actions from '../../action-list';
import {getDefaultState as getClaimDefaultState} from '../state';

const resetShowApplyTravel = () => getClaimDefaultState().showApplyTravel;

const updateShowApplyTravel = (state, action) => action.showApplyTravel;

export default (state = getClaimDefaultState().showApplyTravel, action) => {

    const actionTypes = {
        [actions.UPDATE_CLAIM_NORMAL_SHOW_APPLY_TRAVEL]: updateShowApplyTravel,
        [actions.RESET_CLAIM_NORMAL]: resetShowApplyTravel,
        [actions.COPY_CLAIM_NORMAL]: resetShowApplyTravel
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/normal/reducers/show-apply-travel.js